import { Controller, useFieldArray } from 'react-hook-form';
import React, { useEffect } from 'react';
import Input from 'src/components/Input/Input';

const INITIAL_STATE = {
  name: '',
  description: '',
};

const CloseIcon = ({ onClick = () => {} }) => {
  return (
    <span onClick={onClick} className={'cursor-pointer'}>
      <svg xmlns="http://www.w3.org/2000/svg" width="10" height="9" viewBox="0 0 10 9" fill="none">
        <path d="M1 0.5L9 8.5M9 0.5L1 8.5" stroke="#E50505" strokeLinecap="round" />
      </svg>
    </span>
  );
};

export const WorkflowActionFieldCustomArray = ({ namePrefix = 'action.0', control, watch }) => {
  const customActionChecked = watch(`${namePrefix}.action_fields_custom`);
  const actionEscalatedList = watch(`${namePrefix}.action_escalated_list`);
  const { fields, append, remove } = useFieldArray({
    control,
    name: `${namePrefix}.action_fields_custom_array`,
  });

  useEffect(() => {
    if (customActionChecked && !fields.length) {
      append({ ...INITIAL_STATE });
    }

    if (!customActionChecked && fields.length) {
      fields.forEach((field, index) => remove(index));
    }

    if (!['collect_and_escalate', 'forward_to_email'].includes(actionEscalatedList)) {
      fields.forEach((field, index) => remove(index));
    }
  }, [customActionChecked, actionEscalatedList]);

  return customActionChecked ? (
    <div className={'flex flex-col w-full gap-2.5 px-2'}>
      <ul className={'flex flex-col w-full gap-2.5'}>
        {fields.map((item, index) => (
          <li key={item.id} className={'flex flex-col w-full gap-[5px]'}>
            <div>
              <p
                className={
                  'text-xs text-ebony_opacity_50 font-medium flex flex-row items-center justify-between'
                }
              >
                <span>{index + 1}. Custom field</span>
                {Boolean(index) && <CloseIcon onClick={() => remove(index)} />}
              </p>
            </div>
            <div>
              <Controller
                control={control}
                name={`${namePrefix}.action_fields_custom_array.${index}.name`}
                render={({ field: { onChange, value }, fieldState: { error } }) => (
                  <Input
                    type={'text'}
                    placeholder={'Custom field name'}
                    invalidMessage={error?.message}
                    value={value}
                    isValid={!error?.message}
                    onChange={onChange}
                    className={'!py-2 !px-3.5'}
                  />
                )}
              />
            </div>
            <div>
              <Controller
                control={control}
                name={`${namePrefix}.action_fields_custom_array.${index}.description`}
                render={({ field: { onChange, value }, fieldState: { error } }) => (
                  <Input
                    type={'text'}
                    placeholder={'Custom field description'}
                    invalidMessage={error?.message}
                    value={value}
                    isValid={!error?.message}
                    onChange={onChange}
                    className={'!py-2 !px-3.5'}
                  />
                )}
              />
            </div>
          </li>
        ))}
      </ul>
      <div
        onClick={() => append({ ...INITIAL_STATE })}
        className={'text-[#7A6BE5] text-xs font-medium cursor-pointer hover:underline'}
      >
        Add custom field +
      </div>
    </div>
  ) : null;
};
